import { render, staticRenderFns } from "./ziyuanGtl.vue?vue&type=template&id=2903ec3c&"
import script from "./ziyuanGtl.vue?vue&type=script&lang=js&"
export * from "./ziyuanGtl.vue?vue&type=script&lang=js&"
import style0 from "./ziyuanGtl.vue?vue&type=style&index=0&id=2903ec3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports